import { ChartNode, ChartLink, ChartPoint } from './funnel-chart-types';
import CONFIG from './funnel-chart-config.json';

export const createLink = (
  startItem: ChartNode,
  endItem: ChartNode,
  color: string,
): ChartLink => {
  const points = createLinkPoints(
    startItem.x,
    startItem.y,
    endItem.x,
    endItem.y,
    startItem.width,
    startItem.height,
    endItem.height,
  );

  return {
    color,
    points: addPaddingToLinkPoints(points),
  };
};

const createLinkPoints = (
  startX: number,
  startY: number,
  endX: number,
  endY: number,
  startWidth: number,
  startHeight: number,
  endHeight: number,
): ChartPoint[] => {
  return [
    {
      x: startX + startWidth,
      y: startY,
    },
    {
      x: endX,
      y: endY,
    },
    {
      x: endX,
      y: endY + endHeight,
    },
    {
      x: startX + startWidth,
      y: startY + startHeight,
    },
  ];
};

const addPaddingToLinkPoints = (points: ChartPoint[]): ChartPoint[] => {
  const { inlinePadding } = CONFIG.link;
  const paddedPoints = [
    { ...points[0], x: points[0].x + inlinePadding },
    { ...points[1], x: points[1].x - inlinePadding },
    { ...points[2], x: points[2].x - inlinePadding },
    { ...points[3], x: points[3].x + inlinePadding },
  ];
  return paddedPoints;
};
